import { render, staticRenderFns } from "./Parties.vue?vue&type=template&id=083a7d17&"
import script from "./Parties.vue?vue&type=script&lang=ts&"
export * from "./Parties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports